/**
 * @file view-requested-goods-products.tsx
 * @module app/modals/view-requested-goods-products
 * @description Renders the view requested goods products modal dialog for confirming actions, capturing workflow input, and reporting outcomes to its parent screen.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.3.3
 */

import { Button, Col, Modal, Row } from 'react-bootstrap';
import { Fragment } from 'react';
import Method from '../../utils/methods';
import { CloseModalButton } from '../components';
import ImageWithFallback from '../modules/_common/components/image-with-fallback';
const ViewRequestedGoodsProducts = (props: any) => {
  return (
    <>
      <Modal
        {...props}
        show={props.products && props.show}
        onHide={props.onHide}
        dialogClassName="modal-dialog-centered min-w-lg-794px"
        className="border-r10px"
        centered
      >
        <Modal.Header>
          <Modal.Title>
            {props.products && props.products.length} products
          </Modal.Title>
          <div className="text-end">
            <CloseModalButton onClick={props.onHide} />
          </div>
        </Modal.Header>
        <Modal.Body
          className="mb-3"
          style={{ maxHeight: '500px', overflowY: 'auto' }}
        >
          <Row className="px-lg-6 gy-6">
            {props.products && props.products.length ? (
              <>
                {props.products.map((productVal: any) => {
                  const productName =
                    productVal?.variantName ||
                    productVal?.productName ||
                    productVal?.variant?.title ||
                    '';
                  const productImage =
                    productVal?.media?.[0]?.url ||
                    productVal?.variant?.media?.[0]?.url ||
                    '';
                  return (
                    <Col md={6} key={productVal?.variant?._id || productVal?.variant}>
                      <div className="border border-r8px p-5">
                        <div className="d-flex align-items-center">
                          <div className="me-5 position-relative">
                            <div className="symbol symbol-50px border">
                              <ImageWithFallback
                                src={productImage}
                                alt={productName}
                              />
                            </div>
                          </div>
                          <div className="ms-3">
                            <span className="fs-15 fw-600">
                              {productName.replace(/\s*\)\s*/g, ')')}
                            </span>

                            <div className="fs-14 fw-500 text-muted mt-1">
                              Qty:{' '}
                              {productVal?.quantityTypes?.map(
                                (qtyType: any, index: number) => (
                                  <Fragment key={index}>
                                    {Method.formatQuantityDisplay(
                                      qtyType.type,
                                      qtyType.stockCount
                                    )}
                                    {index <
                                    (productVal?.quantityTypes?.length || 0) - 1
                                      ? ', '
                                      : ''}
                                  </Fragment>
                                )
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </>
            ) : (
              <></>
            )}
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default ViewRequestedGoodsProducts;
